export default "__VITE_ASSET__CiOSuDWT__"